// ══════════════════════════════════════════════════════════════════════════════
// A.D.M — LIVING INTELLIGENCE GLOBE v3.0
// Every marker is AI-driven. Every frame is unique.
// Markers carry confidence, threat evolution, pattern class, historical weight.
// The Earth thinks. The AI controls.
// ══════════════════════════════════════════════════════════════════════════════

export function project(lat, lng, rotY, rotX, W, H, R) {
  const phi   = (90 - lat) * Math.PI / 180;
  const theta = (lng * Math.PI / 180) + rotY;
  const sp = Math.sin(phi), cp = Math.cos(phi);
  const st = Math.sin(theta), ct = Math.cos(theta);
  const cx2 = Math.cos(rotX), sx = Math.sin(rotX);
  const y3 = cp * cx2 - sp * ct * sx;
  const x3 = sp * st;
  const z3 = cp * sx + sp * ct * cx2;
  return { x: W/2 + x3*R, y: H/2 - y3*R, visible: z3 > 0.12, depth: z3 };
}

// ── Continents ────────────────────────────────────────────────────────────────
export const CONTINENTS = [
  [[71,-141],[60,-141],[55,-130],[50,-126],[48,-124],[44,-124],[40,-124],[36,-122],[33,-118],[28,-115],[22,-106],[20,-105],[18,-103],[16,-92],[14,-90],[12,-85],[9,-79],[8,-77],[9,-78],[8,-79],[6,-77],[5,-76],[7,-78],[9,-76],[12,-71],[15,-70],[18,-69],[20,-72],[24,-80],[28,-80],[30,-81],[33,-79],[35,-76],[38,-75],[40,-74],[42,-70],[44,-67],[47,-53],[50,-55],[53,-57],[58,-62],[60,-65],[63,-64],[66,-70],[70,-74],[73,-82],[76,-92],[79,-103],[82,-115],[83,-130],[82,-141],[78,-145],[73,-141],[70,-141]],
  [[83,-35],[80,-20],[75,-20],[70,-25],[65,-38],[60,-45],[60,-50],[65,-55],[70,-60],[73,-65],[76,-68],[80,-55],[83,-45],[85,-40],[83,-35]],
  [[12,-72],[10,-62],[8,-60],[6,-57],[4,-52],[2,-50],[0,-50],[-4,-35],[-8,-35],[-10,-37],[-14,-39],[-20,-40],[-23,-43],[-28,-49],[-30,-51],[-33,-52],[-35,-57],[-38,-58],[-40,-62],[-42,-65],[-45,-65],[-48,-66],[-52,-69],[-55,-67],[-55,-65],[-52,-58],[-50,-55],[-46,-52],[-43,-55],[-40,-62],[-37,-57],[-33,-52],[-28,-49],[-20,-40],[-14,-39],[-4,-35],[0,-50],[4,-52],[8,-60],[12,-72]],
  [[71,28],[68,22],[65,20],[60,18],[57,14],[55,10],[52,5],[50,2],[48,0],[45,-2],[42,3],[40,4],[38,0],[36,-5],[36,-9],[38,-9],[40,-8],[42,-8],[36,-5],[35,0],[36,6],[37,12],[40,15],[42,18],[44,20],[46,22],[48,25],[50,28],[52,30],[55,28],[58,26],[60,28],[62,28],[65,25],[68,22],[71,25],[71,28]],
  [[37,10],[34,12],[28,13],[22,15],[15,14],[10,13],[5,5],[0,5],[-5,8],[-10,12],[-15,12],[-20,15],[-25,15],[-28,17],[-30,17],[-33,18],[-34,22],[-34,27],[-30,30],[-25,33],[-20,35],[-10,40],[0,42],[10,44],[15,42],[20,40],[25,38],[30,33],[32,28],[35,25],[37,22],[37,15],[36,12],[37,10]],
  [[70,50],[65,60],[60,55],[55,62],[50,58],[45,40],[40,38],[36,36],[33,36],[30,48],[28,56],[22,60],[15,44],[10,44],[8,38],[10,32],[12,30],[15,28],[20,26],[22,30],[24,32],[28,30],[30,28],[32,34],[35,36],[38,30],[40,38],[42,42],[45,42],[48,46],[52,58],[55,62],[60,55],[65,60],[70,50]],
  [[70,140],[65,143],[60,140],[55,131],[50,121],[46,134],[42,130],[38,128],[36,131],[34,131],[30,121],[28,116],[25,119],[22,114],[20,110],[18,110],[15,108],[12,109],[10,105],[8,100],[5,101],[2,104],[0,104],[-3,108],[-6,108],[-8,116],[-8,130],[0,142],[2,130],[5,120],[8,112],[10,110],[15,108],[20,110],[25,119],[30,121],[35,135],[40,128],[46,134],[52,131],[58,140],[64,142],[70,140]],
  [[-16,130],[-20,138],[-25,135],[-28,130],[-30,125],[-33,121],[-35,117],[-33,116],[-28,114],[-22,113],[-18,122],[-15,128],[-12,130],[-10,136],[-14,144],[-16,145],[-20,148],[-24,153],[-28,153],[-30,153],[-33,152],[-35,150],[-38,147],[-38,140],[-35,136],[-33,135],[-30,130],[-22,113],[-16,130]],
];

export const CITY_LIGHTS = [
  [40.7,-74,0.55],[34.05,-118,0.6],[51.5,-0.12,0.45],[35.68,139.7,0.65],
  [28.6,77.2,0.5],[31.2,121.5,0.55],[-23.5,-46.6,0.45],[-33.87,151.2,0.4],
  [55.75,37.6,0.5],[48.85,2.35,0.45],[41.38,2.17,0.4],[37.56,126.97,0.5],
  [25.2,55.3,0.45],[1.35,103.8,0.55],[30.05,31.2,0.4],[41.0,29.0,0.45],
  [19.07,72.87,0.4],[6.45,3.39,0.35],[43.7,7.25,0.35],[-26.2,28.0,0.4],
  [45.5,-73.6,0.35],[37.77,-122.42,0.5],[29.76,-95.37,0.45],[41.85,-87.65,0.55],
  [39.9,116.4,0.6],[23.13,113.26,0.5],[22.33,114.17,0.55],
];

const CLASSIFIED_ZONES = [
  { lat:37.23, lng:-115.81, name:'AREA 51',    color:'rgba(255,40,40,0.7)',  size:22 },
  { lat:46.56, lng:-119.49, name:'HANFORD',     color:'rgba(255,100,0,0.6)', size:18 },
  { lat:33.79, lng:-107.65, name:'WS-NMR',      color:'rgba(255,40,40,0.5)', size:16 },
  { lat:38.87, lng:-77.05,  name:'PENTAGON',    color:'rgba(255,200,0,0.5)', size:15 },
  { lat:60.40, lng:26.30,   name:'LOVIISA NUC', color:'rgba(255,80,0,0.55)',size:16 },
  { lat:57.00, lng:23.00,   name:'CLASSIFIED',  color:'rgba(200,0,255,0.4)',size:14 },
  { lat:35.00, lng:136.00,  name:'RESTRICTED',  color:'rgba(255,40,40,0.4)',size:14 },
];

const SATELLITES = Array.from({length:12}, (_,i) => ({
  lat0:  (Math.random()-0.5)*160,
  lng0:  Math.random()*360-180,
  speed: 0.8 + Math.random()*1.4,
  inc:   (Math.random()-0.5)*80,
  type:  ['NRO','NSA','SIGINT','IMINT','ELINT','NAVSTAR'][i%6],
  phase: Math.random()*Math.PI*2,
}));

const SCAN_BANDS = [
  { lat:-80, speed:0.12, width:8,  color:'rgba(0,200,255,0.06)'  },
  { lat:-50, speed:0.09, width:12, color:'rgba(0,255,180,0.04)'  },
  { lat:-20, speed:0.14, width:6,  color:'rgba(100,200,255,0.05)'},
  { lat:10,  speed:0.11, width:10, color:'rgba(0,180,255,0.05)'  },
  { lat:40,  speed:0.13, width:7,  color:'rgba(0,255,150,0.04)'  },
  { lat:70,  speed:0.08, width:14, color:'rgba(0,200,255,0.06)'  },
];

const AURORA_POINTS = [
  {lat:68,lng:-145},{lat:70,lng:-120},{lat:72,lng:-90},{lat:71,lng:-60},
  {lat:70,lng:-30}, {lat:69,lng:10},  {lat:68,lng:40},  {lat:67,lng:80},
  {lat:-68,lng:-60},{lat:-70,lng:-90},{lat:-72,lng:-120},{lat:-71,lng:150},
];

const MEMORY_SHADOWS = [
  {lat:33.39, lng:-104.52, intensity:0.9},
  {lat:32.50, lng:-117.50, intensity:0.85},
  {lat:52.09, lng:1.44,    intensity:0.8},
  {lat:33.44, lng:-112.07, intensity:0.75},
  {lat:38.89, lng:-77.03,  intensity:0.7},
  {lat:50.50, lng:4.47,    intensity:0.7},
  {lat:37.23, lng:-115.81, intensity:0.95},
  {lat:62.84, lng:11.18,   intensity:0.8},
  {lat:25.00, lng:-71.00,  intensity:0.6},
];

const DATA_ARCS = [
  {from:[38.89,-77.03], to:[37.23,-115.81]},
  {from:[51.5,-0.12],   to:[55.75,37.6]},
  {from:[35.68,139.7],  to:[37.56,126.97]},
  {from:[37.23,-115.81],to:[32.50,-117.50]},
  {from:[40.7,-74],     to:[48.85,2.35]},
];

export function initStars(count=1200) {
  return Array.from({length:count}, () => ({
    x:Math.random(), y:Math.random(), r:Math.random()*1.8+0.2,
    b:0.3+Math.random()*0.7, twinkleSpeed:0.5+Math.random()*2.5,
    twinkleOffset:Math.random()*Math.PI*2, colorHue:Math.random()<0.1?(Math.random()*60+180):220,
  }));
}

export function initClouds(count=80) {
  return Array.from({length:count}, () => ({
    lat:(Math.random()-0.5)*160, lng:Math.random()*360-180,
    size:Math.random()*14+4, opacity:Math.random()*0.18+0.03,
    speed:0.08+Math.random()*0.25, type:Math.floor(Math.random()*3),
  }));
}

// ════════════════════════════════════════════════════════════════════════════
// AI MARKER STATE — persistent per-incident intelligence data
// Each incident gets a unique behavioral profile derived from AI analysis
// ════════════════════════════════════════════════════════════════════════════
const markerState = new Map(); // incidentId → { state, age, class, behavior }

function getMarkerState(inc, time) {
  const id  = inc.id || `${inc.lat},${inc.lng}`;
  if (!markerState.has(id)) {
    // Derive behavioral class from incident data — this is AI-driven
    const conf    = (inc.confidence || 70) / 100;
    const isNew   = inc.isLive || false;
    const nuclear = (inc.description||'').toLowerCase().includes('nuclear') ||
                    (inc.name||'').toLowerCase().includes('nuclear') ||
                    (inc.name||'').toLowerCase().includes('hanford') ||
                    (inc.name||'').toLowerCase().includes('area 51');
    const isIntercept = inc.type === 'intercept' || inc.type === 'radar';
    const isConfirmed = (inc.confidence||0) > 90;
    const isHistoric  = !inc.isLive && (inc.witnesses||0) > 100;
    const isTransmedium = (inc.description||'').toLowerCase().includes('transmedium');
    const isCongressional = (inc.classification||'').toLowerCase().includes('congressional') ||
                             (inc.name||'').toLowerCase().includes('congress');

    // AI assigns behavioral class
    const behaviorClass =
      nuclear        ? 'NUCLEAR_PROXIMITY' :
      isTransmedium  ? 'TRANSMEDIUM'       :
      isConfirmed && isIntercept ? 'CONFIRMED_DOD' :
      isCongressional? 'CONGRESSIONAL'     :
      isHistoric     ? 'HISTORIC'          :
      isNew          ? 'LIVE_REPORT'       :
      isIntercept    ? 'INTERCEPT'         :
                       'CIVILIAN_REPORT';

    // Each class gets a unique pulse signature, rotation speed, and ring behavior
    const behaviors = {
      NUCLEAR_PROXIMITY: { pulseRate:3.2, rotSpeed:2.1, rings:5, waveType:'nuclear', glowColor:'255,60,0',    innerColor:'255,150,0' },
      TRANSMEDIUM:       { pulseRate:2.8, rotSpeed:1.6, rings:4, waveType:'radar',   glowColor:'0,220,255',   innerColor:'100,240,255'},
      CONFIRMED_DOD:     { pulseRate:1.8, rotSpeed:0.9, rings:4, waveType:'sonar',   glowColor:'255,40,40',   innerColor:'255,100,80'},
      CONGRESSIONAL:     { pulseRate:1.2, rotSpeed:0.4, rings:3, waveType:'flat',    glowColor:'255,200,0',   innerColor:'255,230,100'},
      HISTORIC:          { pulseRate:0.6, rotSpeed:0.2, rings:2, waveType:'memory',  glowColor:'160,80,255',  innerColor:'200,140,255'},
      LIVE_REPORT:       { pulseRate:2.5, rotSpeed:1.3, rings:3, waveType:'signal',  glowColor:'0,230,100',   innerColor:'80,255,160'},
      INTERCEPT:         { pulseRate:2.2, rotSpeed:1.8, rings:4, waveType:'radar',   glowColor:'255,80,0',    innerColor:'255,160,60'},
      CIVILIAN_REPORT:   { pulseRate:1.0, rotSpeed:0.5, rings:2, waveType:'signal',  glowColor:'0,200,80',    innerColor:'60,240,120'},
    };

    markerState.set(id, {
      class:    behaviorClass,
      behavior: behaviors[behaviorClass] || behaviors.CIVILIAN_REPORT,
      conf,
      born:     time,
      seed:     Math.abs(id.charCodeAt ? id.charCodeAt(0)*7+id.charCodeAt(1)*13 : Math.random()*1000)|0,
      // Each marker gets a unique phase offset so they never pulse in sync
      phaseOffset: Math.random() * Math.PI * 2,
    });
  }
  return markerState.get(id);
}

// ══════════════════════════════════════════════════════════════════════════════
// MAIN DRAW
// ══════════════════════════════════════════════════════════════════════════════
export function drawGlobe(ctx, state, W, H, R, markers, predictions, selectedId) {
  const { rotY, rotX, time, stars, clouds } = state;
  const proj = (lat, lng) => project(lat, lng, rotY, rotX, W, H, R);
  const cx = W/2, cy = H/2;

  ctx.clearRect(0, 0, W, H);

  // Space background
  const spaceBg = ctx.createRadialGradient(cx, cy, 0, cx, cy, Math.max(W,H)*0.8);
  spaceBg.addColorStop(0, '#06080d');
  spaceBg.addColorStop(1, '#020305');
  ctx.fillStyle = spaceBg; ctx.fillRect(0, 0, W, H);

  // AI breathing
  const breathe = 0.97 + 0.03 * Math.sin(time * 0.4);
  ctx.globalAlpha = breathe;

  // Stars
  stars.forEach(st => {
    const x = st.x*W, y = st.y*H;
    if (Math.sqrt((x-cx)**2+(y-cy)**2) > R*1.1) {
      const tw = st.b*(0.5+0.5*Math.sin(time*st.twinkleSpeed+st.twinkleOffset));
      ctx.fillStyle = `hsla(${st.colorHue},40%,90%,${tw*0.8})`;
      ctx.beginPath(); ctx.arc(x, y, st.r*0.5, 0, Math.PI*2); ctx.fill();
    }
  });
  ctx.globalAlpha = 1;

  // Outer glow
  const outerGlow = ctx.createRadialGradient(cx, cy, R*0.9, cx, cy, R*1.6);
  outerGlow.addColorStop(0,'rgba(20,80,200,0.18)'); outerGlow.addColorStop(0.3,'rgba(15,60,160,0.09)');
  outerGlow.addColorStop(0.6,'rgba(0,200,150,0.04)'); outerGlow.addColorStop(1,'rgba(0,0,0,0)');
  ctx.fillStyle=outerGlow; ctx.beginPath(); ctx.arc(cx,cy,R*1.6,0,Math.PI*2); ctx.fill();

  // Ocean
  const oceanGrd = ctx.createRadialGradient(cx-R*0.2, cy-R*0.2, 0, cx, cy, R);
  oceanGrd.addColorStop(0,'#1a3a5c'); oceanGrd.addColorStop(0.3,'#102a48');
  oceanGrd.addColorStop(0.65,'#0a1e35'); oceanGrd.addColorStop(1,'#040a18');
  ctx.fillStyle=oceanGrd; ctx.beginPath(); ctx.arc(cx,cy,R,0,Math.PI*2); ctx.fill();

  ctx.save();
  ctx.beginPath(); ctx.arc(cx,cy,R,0,Math.PI*2); ctx.clip();

  // Memory shadows
  MEMORY_SHADOWS.forEach(mem => {
    const p=proj(mem.lat,mem.lng);
    if(!p.visible) return;
    const pulse=(Math.sin(time*0.3+mem.lat*0.1)+1)/2;
    const opacity=mem.intensity*0.06*(0.7+pulse*0.3);
    const grd=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,R*0.12);
    grd.addColorStop(0,`rgba(180,80,255,${opacity*2})`); grd.addColorStop(0.4,`rgba(100,0,200,${opacity})`); grd.addColorStop(1,'rgba(0,0,0,0)');
    ctx.fillStyle=grd; ctx.beginPath(); ctx.arc(p.x,p.y,R*0.12,0,Math.PI*2); ctx.fill();
  });

  // Scan bands
  SCAN_BANDS.forEach((band,bi) => {
    const scanLat = band.lat + ((time*band.speed*20)%180)-90;
    const p1=proj(Math.max(-88,scanLat),0), p2=proj(Math.min(88,scanLat+band.width),0);
    if(!p1.visible&&!p2.visible) return;
    const yPos=(p1.y+p2.y)/2;
    const bandH=Math.abs(p2.y-p1.y)+2;
    const sa=0.4+0.6*Math.sin(time*1.2+bi);
    const scanGrd=ctx.createLinearGradient(cx-R,yPos,cx+R,yPos);
    scanGrd.addColorStop(0,'rgba(0,0,0,0)'); scanGrd.addColorStop(0.3,band.color.replace('0.06',String(0.06*sa)));
    scanGrd.addColorStop(0.5,band.color.replace('0.06',String(0.12*sa))); scanGrd.addColorStop(0.7,band.color.replace('0.06',String(0.06*sa))); scanGrd.addColorStop(1,'rgba(0,0,0,0)');
    ctx.fillStyle=scanGrd; ctx.fillRect(cx-R,yPos-bandH/2,R*2,bandH);
  });

  // Grid
  for(let lat=-80;lat<=80;lat+=10){
    const isSpec=lat===0||Math.abs(lat)===23||Math.abs(lat)===66;
    ctx.beginPath(); let m=false;
    for(let lng=-180;lng<=180;lng+=2){const p=proj(lat,lng);if(p.visible){if(m)ctx.lineTo(p.x,p.y);else{ctx.moveTo(p.x,p.y);m=true;}}else{m=false;}}
    ctx.strokeStyle=isSpec?'rgba(255,210,60,0.3)':'rgba(255,210,60,0.07)'; ctx.lineWidth=isSpec?0.8:0.35; ctx.stroke();
  }
  for(let lng=-180;lng<180;lng+=10){
    ctx.beginPath(); let m=false;
    for(let lat=-88;lat<=88;lat+=2){const p=proj(lat,lng);if(p.visible){if(m)ctx.lineTo(p.x,p.y);else{ctx.moveTo(p.x,p.y);m=true;}}else{m=false;}}
    ctx.strokeStyle=lng===0?'rgba(255,210,60,0.25)':'rgba(255,210,60,0.06)'; ctx.lineWidth=lng===0?0.7:0.3; ctx.stroke();
  }

  // Continents
  CONTINENTS.forEach(poly=>{
    const pts=poly.map(([la,lo])=>proj(la,lo));
    if(pts.filter(p=>p.visible).length<3) return;
    ctx.beginPath(); let moved=false;
    pts.forEach(p=>{if(p.visible){if(moved)ctx.lineTo(p.x,p.y);else{ctx.moveTo(p.x,p.y);moved=true;}}else{moved=false;}});
    ctx.closePath();
    const lGrd=ctx.createLinearGradient(cx-R,cy-R,cx+R,cy+R);
    lGrd.addColorStop(0,'rgba(62,88,46,0.97)'); lGrd.addColorStop(0.5,'rgba(50,74,36,0.95)'); lGrd.addColorStop(1,'rgba(38,56,26,0.93)');
    ctx.fillStyle=lGrd; ctx.fill();
    ctx.strokeStyle='rgba(90,138,60,0.18)'; ctx.lineWidth=0.5; ctx.stroke();
  });

  // City lights
  CITY_LIGHTS.forEach(([la,lo,intensity])=>{
    const p=proj(la,lo); if(!p.visible) return;
    const flicker=intensity*(0.85+0.15*Math.sin(time*3.7+la*7));
    const grd=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,R*0.06);
    grd.addColorStop(0,`rgba(255,220,100,${flicker*0.4})`); grd.addColorStop(0.5,`rgba(255,160,40,${flicker*0.15})`); grd.addColorStop(1,'rgba(255,100,0,0)');
    ctx.fillStyle=grd; ctx.beginPath(); ctx.arc(p.x,p.y,R*0.06,0,Math.PI*2); ctx.fill();
  });

  // Clouds
  clouds.forEach(cl=>{
    const lng=cl.lng+time*cl.speed*15;
    const p=proj(cl.lat,lng); if(!p.visible) return;
    const opacity=cl.opacity*(0.8+0.2*Math.sin(time*0.5+cl.lat));
    if(cl.type===1){
      const grd=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,cl.size*1.8*(R/200));
      grd.addColorStop(0,`rgba(100,120,140,${opacity*1.5})`); grd.addColorStop(1,'rgba(0,0,0,0)');
      ctx.fillStyle=grd; ctx.beginPath(); ctx.arc(p.x,p.y,cl.size*1.8*(R/200),0,Math.PI*2); ctx.fill();
    } else {
      const grd=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,cl.size*(R/180));
      grd.addColorStop(0,`rgba(220,235,250,${opacity})`); grd.addColorStop(1,'rgba(255,255,255,0)');
      ctx.fillStyle=grd; ctx.beginPath(); ctx.arc(p.x,p.y,cl.size*(R/180),0,Math.PI*2); ctx.fill();
    }
  });

  // Aurora
  const auroraI=0.5+0.5*Math.sin(time*0.18);
  if(auroraI>0.3){
    for(let i=0;i<AURORA_POINTS.length/2;i++){
      const a=AURORA_POINTS[i],b=AURORA_POINTS[(i+1)%(AURORA_POINTS.length/2)];
      const p1=proj(a.lat,a.lng+time*3),p2=proj(b.lat,b.lng+time*3);
      if(!p1.visible||!p2.visible) continue;
      const hue=120+40*Math.sin(time*0.5+i);
      ctx.strokeStyle=`hsla(${hue},100%,60%,${auroraI*0.2})`; ctx.lineWidth=3+auroraI*4;
      ctx.beginPath(); ctx.moveTo(p1.x,p1.y); ctx.lineTo(p2.x,p2.y); ctx.stroke();
    }
    for(let i=AURORA_POINTS.length/2;i<AURORA_POINTS.length;i++){
      const a=AURORA_POINTS[i],b=AURORA_POINTS[i+1]||AURORA_POINTS[AURORA_POINTS.length/2];
      const p1=proj(a.lat,a.lng-time*2.5),p2=proj(b.lat,b.lng-time*2.5);
      if(!p1.visible||!p2.visible) continue;
      const hue=180+40*Math.sin(time*0.4+i);
      ctx.strokeStyle=`hsla(${hue},100%,65%,${auroraI*0.18})`; ctx.lineWidth=2+auroraI*3;
      ctx.beginPath(); ctx.moveTo(p1.x,p1.y); ctx.lineTo(p2.x,p2.y); ctx.stroke();
    }
  }

  // Classified zones
  CLASSIFIED_ZONES.forEach((zone,zi)=>{
    const p=proj(zone.lat,zone.lng); if(!p.visible) return;
    const blink=Math.sin(time*2.2+zi*1.3)>0.3?1:0.3;
    const pulse=(Math.sin(time*3+zi)+1)/2;
    ctx.beginPath(); ctx.arc(p.x,p.y,zone.size*(0.9+pulse*0.2),0,Math.PI*2);
    ctx.strokeStyle=zone.color.replace(/[\d.]+\)$/,`${0.4*blink})`);
    ctx.lineWidth=1; ctx.setLineDash([3,3]); ctx.stroke(); ctx.setLineDash([]);
    ctx.beginPath(); ctx.arc(p.x,p.y,3,0,Math.PI*2);
    ctx.fillStyle=zone.color.replace(/[\d.]+\)$/,`${0.8*blink})`); ctx.fill();
    if(blink>0.5&&R>100){
      ctx.font=`${Math.max(6,R*0.018)}px monospace`;
      ctx.fillStyle=`rgba(255,200,0,${0.6*blink})`; ctx.textAlign='center';
      ctx.fillText(zone.name,p.x,p.y-zone.size-3);
    }
  });

  // Data arcs
  DATA_ARCS.forEach((arc,ai)=>{
    const p1=proj(arc.from[0],arc.from[1]),p2=proj(arc.to[0],arc.to[1]);
    if(!p1.visible&&!p2.visible) return;
    const phase=((time*0.8+ai*0.7)%1);
    const alpha=0.3+0.4*Math.sin(time*1.5+ai);
    ctx.beginPath(); ctx.moveTo(p1.x,p1.y); ctx.lineTo(p2.x,p2.y);
    ctx.strokeStyle=`rgba(0,200,255,${alpha*0.3})`; ctx.lineWidth=0.8; ctx.stroke();
    const px=p1.x+(p2.x-p1.x)*phase, py=p1.y+(p2.y-p1.y)*phase;
    const pgrd=ctx.createRadialGradient(px,py,0,px,py,5);
    pgrd.addColorStop(0,`rgba(0,255,220,${alpha})`); pgrd.addColorStop(1,'rgba(0,200,255,0)');
    ctx.fillStyle=pgrd; ctx.beginPath(); ctx.arc(px,py,5,0,Math.PI*2); ctx.fill();
  });

  // Heat signatures
  [{lat:25,lng:50},{lat:-10,lng:120},{lat:40,lng:90},{lat:0,lng:30},{lat:30,lng:-100}].forEach((hz,hi)=>{
    const p=proj(hz.lat,hz.lng); if(!p.visible) return;
    const intensity=0.4+0.6*Math.sin(time*0.7+hi*1.1);
    const grd=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,R*0.08);
    grd.addColorStop(0,`rgba(255,80,0,${intensity*0.06})`); grd.addColorStop(1,'rgba(255,0,0,0)');
    ctx.fillStyle=grd; ctx.beginPath(); ctx.arc(p.x,p.y,R*0.08,0,Math.PI*2); ctx.fill();
  });

  // Magnetic field lines
  for(let i=0;i<4;i++){
    ctx.beginPath();
    for(let lat2=-80;lat2<=80;lat2+=3){
      const p=proj(lat2,(i*45+time*2)%360-180);
      if(p.visible){if(lat2===-80)ctx.moveTo(p.x,p.y);else ctx.lineTo(p.x,p.y);}
    }
    ctx.strokeStyle=`rgba(100,150,255,${0.025+0.015*Math.sin(time*0.2+i)})`; ctx.lineWidth=0.5; ctx.stroke();
  }

  // ── AI-DRIVEN MARKERS ───────────────────────────────────────────────────────
  if(markers){
    // Sort by depth — draw far markers first
    const visible = markers
      .map(inc => {
        if(!inc.lat||!inc.lng) return null;
        const p = proj(inc.lat, inc.lng);
        return p.visible ? { inc, p } : null;
      })
      .filter(Boolean)
      .sort((a,b) => a.p.depth - b.p.depth);

    visible.forEach(({inc, p}) => {
      if(inc.isSeismic || inc.type==='seismic') {
        drawSeismicEvent(ctx,p.x,p.y,time,inc,R,selectedId===inc.id);
      } else if(inc.isAtmospheric || inc.type==='atmospheric') {
        drawAtmosphericEvent(ctx,p.x,p.y,time,inc,R,selectedId===inc.id);
      } else {
        drawAIMarker(ctx,p.x,p.y,time,inc,R,selectedId===inc.id,p.depth);
      }
    });
  }

  ctx.restore();

  // Atmosphere
  const rim=ctx.createRadialGradient(cx,cy,R*0.83,cx,cy,R*1.03);
  rim.addColorStop(0,'rgba(0,0,0,0)'); rim.addColorStop(0.5,'rgba(30,90,210,0.08)');
  rim.addColorStop(0.8,'rgba(50,120,255,0.18)'); rim.addColorStop(0.95,'rgba(80,150,255,0.12)'); rim.addColorStop(1,'rgba(100,170,255,0.02)');
  ctx.fillStyle=rim; ctx.beginPath(); ctx.arc(cx,cy,R*1.03,0,Math.PI*2); ctx.fill();
  ctx.strokeStyle=`rgba(0,200,255,${0.06+0.04*Math.sin(time*2.1)})`; ctx.lineWidth=1.5;
  ctx.beginPath(); ctx.arc(cx,cy,R*1.015,0,Math.PI*2); ctx.stroke();
  ctx.strokeStyle='rgba(60,120,255,0.15)'; ctx.lineWidth=0.8;
  ctx.beginPath(); ctx.arc(cx,cy,R,0,Math.PI*2); ctx.stroke();
  const spec=ctx.createRadialGradient(cx-R*0.28,cy-R*0.3,0,cx-R*0.15,cy-R*0.15,R*0.6);
  spec.addColorStop(0,'rgba(200,225,255,0.08)'); spec.addColorStop(1,'rgba(0,0,0,0)');
  ctx.fillStyle=spec; ctx.beginPath(); ctx.arc(cx,cy,R,0,Math.PI*2); ctx.fill();

  // Satellites
  SATELLITES.forEach((sat,si)=>{
    const t2=time*sat.speed+sat.phase;
    const p=proj(sat.lat0+sat.inc*Math.sin(t2*0.3),(sat.lng0+t2*40)%360-180);
    if(!p.visible||Math.sin(time*4+si)<=0) return;
    const angle=Math.atan2(p.y-cy,p.x-cx);
    const sx2=cx+Math.cos(angle)*R*1.06, sy2=cy+Math.sin(angle)*R*1.06;
    ctx.fillStyle='rgba(0,255,200,0.8)'; ctx.beginPath(); ctx.arc(sx2,sy2,1.5,0,Math.PI*2); ctx.fill();
    ctx.strokeStyle='rgba(0,200,150,0.2)'; ctx.lineWidth=0.5;
    ctx.beginPath(); ctx.moveTo(p.x,p.y); ctx.lineTo(sx2,sy2); ctx.stroke();
    if(R>120){ctx.font='5px monospace';ctx.fillStyle='rgba(0,255,150,0.5)';ctx.textAlign='center';ctx.fillText(sat.type,sx2,sy2-5);}
  });

  // Prediction zones
  if(predictions) predictions.forEach((pred,i)=>{
    if(!pred.lat||!pred.lng) return;
    const p=proj(pred.lat,pred.lng); if(!p.visible) return;
    const pulse=(Math.sin(time*1.8+i*1.1)+1)/2;
    const conf=(pred.confidence||80)/100;
    [60,42,28,16].forEach((rad,ri)=>{
      const ringR=rad*(0.7+pulse*0.4)*(R/300);
      ctx.beginPath(); ctx.arc(p.x,p.y,ringR,0,Math.PI*2);
      ctx.strokeStyle=`rgba(0,230,80,${(0.25-ri*0.05)*conf*(0.5+pulse*0.5)})`;
      ctx.lineWidth=1.2; ctx.stroke();
    });
    for(let seg=0;seg<8;seg++){
      const a1=time*1.5+seg*(Math.PI/4), a2=a1+0.45;
      ctx.beginPath(); ctx.arc(p.x,p.y,22*(R/300),a1,a2);
      ctx.strokeStyle=`rgba(0,255,120,${0.6*conf})`; ctx.lineWidth=1.5; ctx.stroke();
    }
    const cgrd=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,8*(R/300));
    cgrd.addColorStop(0,`rgba(0,255,100,${0.9+pulse*0.1})`); cgrd.addColorStop(1,'rgba(0,150,40,0)');
    ctx.fillStyle=cgrd; ctx.beginPath(); ctx.arc(p.x,p.y,8*(R/300),0,Math.PI*2); ctx.fill();
    drawUFO(ctx,p.x+(10+pulse*4)*(R/300)*3,p.y-(12+pulse*3)*(R/300)*3,R*0.04);
  });
}

// ══════════════════════════════════════════════════════════════════════════════
// AI MARKER — Each incident has a unique living visual driven by its AI profile
// ══════════════════════════════════════════════════════════════════════════════
function drawAIMarker(ctx, x, y, time, inc, R, isSelected, depth) {
  const ms    = getMarkerState(inc, time);
  const beh   = ms.behavior;
  const scale = R / 300;
  const conf  = ms.conf;
  const age   = (time - ms.born) * 0.001;

  // Fade markers near the horizon — smooth edge, not hard cutoff
  // depth goes from ~0.12 (horizon) to ~1.0 (center-facing)
  const horizonFade = Math.min(1, (depth - 0.12) / 0.15);
  if (horizonFade <= 0) return;
  ctx.globalAlpha = horizonFade;

  // ── Unique timing per marker ────────────────────────────────────────────────
  const t        = time + ms.phaseOffset;
  const pulse    = (Math.sin(t * beh.pulseRate) + 1) / 2;
  const fastPulse= (Math.sin(t * beh.pulseRate * 2.3) + 1) / 2;
  const glow     = beh.glowColor;
  const inner    = beh.innerColor;

  // ── Base size — varies by confidence and class ──────────────────────────────
  const baseSize = (10 + conf*12) * scale * (0.88 + pulse*0.24);
  const isNew    = age < 8; // "just appeared" animation

  // ── Outer energy field — unique per class ───────────────────────────────────
  const fieldR = baseSize * (isSelected ? 2.4 : 1.8);
  const grd    = ctx.createRadialGradient(x, y, 0, x, y, fieldR);
  grd.addColorStop(0, `rgba(${glow},${0.25 + pulse*0.2})`);
  grd.addColorStop(0.4,`rgba(${glow},${0.1 + pulse*0.08})`);
  grd.addColorStop(1,   'rgba(0,0,0,0)');
  ctx.fillStyle = grd;
  ctx.beginPath(); ctx.arc(x, y, fieldR, 0, Math.PI*2); ctx.fill();

  // ── Behavior-specific rings ─────────────────────────────────────────────────
  if(beh.waveType === 'nuclear') {
    // Nuclear: hard concentric rings that don't expand, just throb
    for(let ri=0; ri<beh.rings; ri++) {
      const r = baseSize*(0.6+ri*0.55);
      const a = (0.6-ri*0.12)*(0.5+pulse*0.5)*conf;
      ctx.beginPath(); ctx.arc(x,y,r,0,Math.PI*2);
      ctx.strokeStyle=`rgba(${glow},${a})`;
      ctx.lineWidth=(1.6-ri*0.25)*scale*2; ctx.stroke();
    }
    // Radiation symbol wedges
    ctx.save(); ctx.translate(x,y); ctx.rotate(time*0.5+ms.phaseOffset);
    for(let w=0;w<3;w++){
      ctx.rotate(Math.PI*2/3);
      ctx.beginPath(); ctx.moveTo(0,baseSize*0.3); ctx.arc(0,0,baseSize*0.7,Math.PI/2-0.45,Math.PI/2+0.45); ctx.closePath();
      ctx.fillStyle=`rgba(${glow},${0.35+pulse*0.25})`; ctx.fill();
    }
    ctx.restore();

  } else if(beh.waveType === 'radar') {
    // Radar: sweeping arc + static rings
    const sweep = (time * beh.rotSpeed + ms.phaseOffset) % (Math.PI*2);
    for(let ri=0;ri<beh.rings;ri++){
      ctx.beginPath(); ctx.arc(x,y,baseSize*(0.7+ri*0.6),0,Math.PI*2);
      ctx.strokeStyle=`rgba(${glow},${(0.4-ri*0.08)*conf*(0.5+pulse*0.3)})`;
      ctx.lineWidth=(1.4-ri*0.25)*scale*2; ctx.stroke();
    }
    // Sweep beam
    ctx.save(); ctx.translate(x,y);
    ctx.beginPath(); ctx.moveTo(0,0);
    ctx.arc(0,0,baseSize*2.2,sweep,sweep+0.7);
    ctx.closePath();
    ctx.fillStyle=`rgba(${glow},${0.18+pulse*0.12})`; ctx.fill();
    ctx.restore();

  } else if(beh.waveType === 'sonar') {
    // Sonar: expanding rings that fade out
    for(let ri=0;ri<beh.rings+1;ri++){
      const phase=((t*1.2+ri*0.4)%3)/3;
      const waveR=baseSize*(0.5+phase*2.5);
      const a=(1-phase)*0.6*conf;
      ctx.beginPath(); ctx.arc(x,y,waveR,0,Math.PI*2);
      ctx.strokeStyle=`rgba(${glow},${a})`;
      ctx.lineWidth=(2-ri*0.3)*scale*2; ctx.stroke();
    }

  } else if(beh.waveType === 'memory') {
    // Memory (historical): slow, ancient-looking, purple tones
    for(let ri=0;ri<beh.rings;ri++){
      const r=baseSize*(1+ri*0.8)*(0.9+pulse*0.1);
      ctx.beginPath(); ctx.arc(x,y,r,0,Math.PI*2);
      ctx.strokeStyle=`rgba(${glow},${(0.3-ri*0.1)*conf})`;
      ctx.lineWidth=0.8*scale*2; ctx.setLineDash([4,4]); ctx.stroke(); ctx.setLineDash([]);
    }

  } else {
    // Default signal: classic EM rings
    for(let ri=0;ri<beh.rings;ri++){
      ctx.beginPath(); ctx.arc(x,y,baseSize*(0.8+ri*0.65),0,Math.PI*2);
      ctx.strokeStyle=`rgba(${glow},${(0.38-ri*0.08)*conf*(0.5+pulse*0.5)})`;
      ctx.lineWidth=(1.3-ri*0.25)*scale*2; ctx.stroke();
    }
  }

  // ── Core glyph — unique per class, AI-driven ───────────────────────────────
  ctx.save();
  ctx.translate(x, y);
  ctx.rotate(time * beh.rotSpeed + ms.phaseOffset);

  const gs = baseSize * 0.72 * (isNew ? Math.min(1, age/2) : 1); // grow-in animation

  if(ms.class === 'NUCLEAR_PROXIMITY') {
    // Triangle warning symbol
    ctx.beginPath();
    ctx.moveTo(0, -gs*1.1); ctx.lineTo(gs*0.95, gs*0.6); ctx.lineTo(-gs*0.95, gs*0.6);
    ctx.closePath();
    ctx.fillStyle=`rgba(${inner},${0.85+fastPulse*0.15})`; ctx.fill();
    ctx.strokeStyle=`rgba(255,255,200,0.9)`; ctx.lineWidth=0.7*scale*2; ctx.stroke();
    // Exclamation
    ctx.fillStyle='rgba(0,0,0,0.9)'; ctx.font=`bold ${gs*0.9}px monospace`;
    ctx.textAlign='center'; ctx.textBaseline='middle';
    ctx.fillText('!', 0, gs*0.15);

  } else if(ms.class === 'TRANSMEDIUM') {
    // Two overlapping diamonds (air + water)
    ctx.beginPath();
    ctx.moveTo(0,-gs); ctx.lineTo(gs*0.7,0); ctx.lineTo(0,gs); ctx.lineTo(-gs*0.7,0);
    ctx.closePath(); ctx.fillStyle=`rgba(${inner},0.7)`; ctx.fill();
    ctx.rotate(Math.PI/4);
    ctx.beginPath();
    ctx.moveTo(0,-gs*0.7); ctx.lineTo(gs*0.5,0); ctx.lineTo(0,gs*0.7); ctx.lineTo(-gs*0.5,0);
    ctx.closePath();
    ctx.fillStyle=`rgba(0,220,255,0.5)`; ctx.fill();
    ctx.strokeStyle=`rgba(${glow},0.9)`; ctx.lineWidth=0.7*scale*2; ctx.stroke();

  } else if(ms.class === 'CONFIRMED_DOD') {
    // Pentagon — 5-sided
    ctx.beginPath();
    for(let v=0;v<5;v++){
      const a=v*(Math.PI*2/5)-Math.PI/2;
      if(v===0) ctx.moveTo(Math.cos(a)*gs,Math.sin(a)*gs);
      else ctx.lineTo(Math.cos(a)*gs,Math.sin(a)*gs);
    }
    ctx.closePath();
    ctx.fillStyle=`rgba(${inner},${0.8+fastPulse*0.2})`; ctx.fill();
    ctx.strokeStyle=`rgba(255,200,150,0.9)`; ctx.lineWidth=0.7*scale*2; ctx.stroke();

  } else if(ms.class === 'CONGRESSIONAL') {
    // Seal-like octagon
    ctx.beginPath();
    for(let v=0;v<8;v++){
      const a=v*(Math.PI/4);
      if(v===0) ctx.moveTo(Math.cos(a)*gs,Math.sin(a)*gs);
      else ctx.lineTo(Math.cos(a)*gs,Math.sin(a)*gs);
    }
    ctx.closePath();
    ctx.fillStyle=`rgba(${inner},0.75)`; ctx.fill();
    ctx.strokeStyle=`rgba(255,240,100,0.9)`; ctx.lineWidth=0.7*scale*2; ctx.stroke();

  } else if(ms.class === 'HISTORIC') {
    // Circle with cross — ancient marker
    ctx.beginPath(); ctx.arc(0,0,gs,0,Math.PI*2);
    ctx.fillStyle=`rgba(${inner},0.6)`; ctx.fill();
    ctx.strokeStyle=`rgba(${glow},0.7)`; ctx.lineWidth=0.7*scale*2; ctx.stroke();
    ctx.beginPath(); ctx.moveTo(-gs,0); ctx.lineTo(gs,0); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(0,-gs); ctx.lineTo(0,gs); ctx.stroke();

  } else {
    // Default: rotating diamond
    ctx.beginPath();
    ctx.moveTo(0,-gs); ctx.lineTo(gs*0.65,0);
    ctx.lineTo(0,gs);  ctx.lineTo(-gs*0.65,0);
    ctx.closePath();
    ctx.fillStyle=`rgba(${inner},${0.8+fastPulse*0.2})`; ctx.fill();
    ctx.strokeStyle=`rgba(${glow},0.9)`;
    ctx.lineWidth=0.8*scale*2; ctx.stroke();
    // Inner cross
    ctx.strokeStyle=`rgba(${glow},${0.6+fastPulse*0.4})`; ctx.lineWidth=0.6*scale*2;
    ctx.beginPath(); ctx.moveTo(-gs*0.3,0); ctx.lineTo(gs*0.3,0); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(0,-gs*0.3); ctx.lineTo(0,gs*0.3); ctx.stroke();
  }

  ctx.restore();

  // ── Selection expansion wave ────────────────────────────────────────────────
  if(isSelected){
    const waveR=(baseSize*2.5+pulse*baseSize)*1.1;
    ctx.beginPath(); ctx.arc(x,y,waveR,0,Math.PI*2);
    ctx.strokeStyle=`rgba(${glow},${0.5*(1-pulse)})`; ctx.lineWidth=2*scale*2; ctx.stroke();
    // Second ring
    ctx.beginPath(); ctx.arc(x,y,waveR*0.7,0,Math.PI*2);
    ctx.strokeStyle=`rgba(255,255,255,${0.3*(1-pulse)})`; ctx.lineWidth=1*scale*2; ctx.stroke();
  }

  // ── Confidence core ───────────────────────────────────────────────────────
  const centerGrd=ctx.createRadialGradient(x,y,0,x,y,5*scale);
  centerGrd.addColorStop(0,`rgba(255,255,255,${0.8+fastPulse*0.2})`);
  centerGrd.addColorStop(0.5,`rgba(${glow},${0.5*conf})`);
  centerGrd.addColorStop(1,'rgba(0,0,0,0)');
  ctx.fillStyle=centerGrd; ctx.beginPath(); ctx.arc(x,y,5*scale,0,Math.PI*2); ctx.fill();

  // ── AI class label ────────────────────────────────────────────────────────
  if(R > 130 && isSelected){
    const labelText = ms.class.replace(/_/g,' ');
    ctx.font=`${Math.max(7,R*0.022)}px monospace`;
    ctx.fillStyle=`rgba(${glow},0.85)`;
    ctx.textAlign='center';
    ctx.fillText(labelText, x, y - baseSize*1.6 - 4);
    ctx.fillStyle=`rgba(255,255,255,0.5)`;
    ctx.fillText(`${Math.round(ms.conf*100)}% conf`, x, y - baseSize*1.6 - 4 + Math.max(8,R*0.025));
  }

  ctx.globalAlpha = 1; // Always reset
}

// ── Seismic Event ─────────────────────────────────────────────────────────────
function drawSeismicEvent(ctx, x, y, time, inc, R, isSelected) {
  const scale = R/300;
  const mag   = Math.max(2.5, Math.min(9.5, inc.magnitude||3));
  const size  = (mag/9.5)*22*scale;
  const alpha = 0.5+((Math.sin(time*2.8+(inc.lat||0))+1)/2)*0.5;

  for(let ri=0;ri<Math.min(Math.floor(mag),6);ri++){
    const phase=((time*(0.8+ri*0.15)+ri*0.3)%3)/3;
    const waveR=size*(0.5+phase*3);
    const wa=(1-phase)*alpha*(mag/9.5);
    ctx.beginPath(); ctx.arc(x,y,waveR,0,Math.PI*2);
    ctx.strokeStyle=mag>=7?`rgba(255,40,0,${wa*0.7})`:mag>=5?`rgba(255,140,0,${wa*0.6})`:`rgba(255,200,50,${wa*0.5})`;
    ctx.lineWidth=(1.5-ri*0.2)*scale*2; ctx.stroke();
  }
  const coreColor=mag>=7?'255,40,0':mag>=5?'255,130,0':'255,190,50';
  const cg=ctx.createRadialGradient(x,y,0,x,y,size*0.8);
  cg.addColorStop(0,`rgba(${coreColor},0.95)`); cg.addColorStop(0.6,`rgba(${coreColor},0.4)`); cg.addColorStop(1,'rgba(0,0,0,0)');
  ctx.fillStyle=cg; ctx.beginPath(); ctx.arc(x,y,size*0.8,0,Math.PI*2); ctx.fill();
  const cs=size*0.5;
  ctx.strokeStyle=`rgba(255,255,255,${0.7+((Math.sin(time*6+(inc.lat||0))+1)/2)*0.3})`; ctx.lineWidth=scale*1.5;
  ctx.beginPath(); ctx.moveTo(x-cs,y); ctx.lineTo(x+cs,y); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(x,y-cs); ctx.lineTo(x,y+cs); ctx.stroke();
  if(R>100){
    ctx.font=`bold ${Math.max(7,R*0.028)}px monospace`;
    ctx.fillStyle=`rgba(255,220,100,0.9)`; ctx.textAlign='center';
    ctx.fillText(`M${mag.toFixed(1)}`,x,y-size*0.9-3);
  }
}

// ── Atmospheric Event ─────────────────────────────────────────────────────────
function drawAtmosphericEvent(ctx, x, y, time, inc, R, isSelected) {
  const scale=R/300;
  const seed=(inc.lat||0)*7;
  const pulse=(Math.sin(time*1.4+seed)+1)/2;
  const colors={volcanic:{core:'255,80,0',ring:'255,120,40'},storm:{core:'100,160,255',ring:'150,200,255'},wildfire:{core:'255,100,0',ring:'255,160,60'},natural:{core:'0,200,180',ring:'50,230,210'}};
  const c=colors[inc.eventType]||colors.natural;
  const size=14*scale;
  for(let ri=0;ri<3;ri++){
    const rot=time*(0.4+ri*0.2)+seed*0.5+ri*(Math.PI*2/3);
    const ringR=size*(1.2+ri*0.8);
    for(let seg=0;seg<6;seg++){
      const a1=rot+seg*(Math.PI/3), a2=a1+0.35;
      ctx.beginPath(); ctx.arc(x,y,ringR,a1,a2);
      ctx.strokeStyle=`rgba(${c.ring},${(0.5-ri*0.12)*(0.7+pulse*0.3)})`; ctx.lineWidth=(1.5-ri*0.3)*scale*2; ctx.stroke();
    }
  }
  const grd=ctx.createRadialGradient(x,y,0,x,y,size);
  grd.addColorStop(0,`rgba(${c.core},0.9)`); grd.addColorStop(1,'rgba(0,0,0,0)');
  ctx.fillStyle=grd; ctx.beginPath(); ctx.arc(x,y,size,0,Math.PI*2); ctx.fill();
  if(R>100){
    const icon=inc.eventType==='volcanic'?'🌋':inc.eventType==='storm'?'⛈':inc.eventType==='wildfire'?'🔥':'🌊';
    ctx.font=`${Math.max(8,R*0.03)}px serif`; ctx.textAlign='center';
    ctx.fillText(icon,x,y+size+10*scale);
  }
}

// ── UFO Saucer ────────────────────────────────────────────────────────────────
function drawUFO(ctx, cx, cy, size) {
  ctx.save(); ctx.globalAlpha=0.8;
  ctx.shadowColor='rgba(130,170,255,0.5)'; ctx.shadowBlur=10;
  ctx.beginPath(); ctx.ellipse(cx+size,cy+size*0.55,size*1.15,size*0.28,0,0,Math.PI*2);
  const g=ctx.createLinearGradient(cx,cy+size*0.3,cx,cy+size*0.8);
  g.addColorStop(0,'rgba(200,215,235,0.9)'); g.addColorStop(1,'rgba(150,170,200,0.75)');
  ctx.fillStyle=g; ctx.fill();
  ctx.beginPath(); ctx.ellipse(cx+size,cy+size*0.28,size*0.46,size*0.4,0,Math.PI,Math.PI*2);
  ctx.fillStyle='rgba(170,210,255,0.6)'; ctx.fill();
  for(let li=0;li<5;li++){
    const la=li*(Math.PI/5), lx=cx+size+Math.cos(la)*size*0.9, ly=cy+size*0.55+Math.sin(la)*size*0.2;
    ctx.fillStyle=['rgba(0,220,255,0.9)','rgba(255,220,0,0.9)','rgba(0,255,120,0.9)'][li%3];
    ctx.beginPath(); ctx.arc(lx,ly,2,0,Math.PI*2); ctx.fill();
  }
  ctx.shadowBlur=0; ctx.globalAlpha=1; ctx.restore();
}
